var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWeddingSuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 182,
    x2: 297.004,
    xlinkHref: "#lg1",
    y1: 105.517,
    y2: 220.522
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.773,
    x2: 278.554,
    y1: 177.766,
    y2: 179.882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0868,
    stopColor: "#f1f6fc",
    stopOpacity: 0.087
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#b2ceec",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#8ab5e2",
    stopOpacity: 0.836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bacdf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 126.464,
    y2: 55.127
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.487,
    x2: 273.66,
    xlinkHref: "#lg3",
    y1: 172.835,
    y2: 172.835
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.128,
    x2: 266.878,
    xlinkHref: "#lg3",
    y1: 61.919,
    y2: 88.139
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 43,
    x2: 43,
    xlinkHref: "#lg1",
    y1: 475.214,
    y2: 488.771
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 467,
    x2: 467,
    xlinkHref: "#lg1",
    y1: 475.214,
    y2: 488.771
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.679,
    x2: 457.76,
    xlinkHref: "#lg4",
    y1: 188.027,
    y2: 383.108
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.952,
    x2: 368.952,
    xlinkHref: "#lg5",
    y1: 137.421,
    y2: 185.421
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.475,
    x2: 321.475,
    xlinkHref: "#lg5",
    y1: 441.13,
    y2: 504.281
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 403,
    x2: 220.997,
    xlinkHref: "#lg5",
    y1: 391.825,
    y2: 391.825
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.66,
    x2: 207.629,
    xlinkHref: "#lg4",
    y1: 234.194,
    y2: 409.815
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.519,
    x2: 221.852,
    xlinkHref: "#lg5",
    y1: 136.94,
    y2: 152.273
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.525,
    x2: 188.525,
    xlinkHref: "#lg5",
    y1: 447.797,
    y2: 499.199
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 2.142,
    y2: 31.542
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3432,
    stopColor: "#cde0f3",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#92bae4",
    stopOpacity: 0.787
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: -5.483,
    y2: 64.102
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.636,
    x2: 210.305,
    xlinkHref: "#lg1",
    y1: 47.03,
    y2: 70.234
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.308,
    x2: 326.971,
    xlinkHref: "#lg1",
    y1: 40.02,
    y2: 68.683
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.872,
    x2: 219.032,
    xlinkHref: "#lg5",
    y1: 422.591,
    y2: 322.751
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.458,
    x2: 220.698,
    xlinkHref: "#lg5",
    y1: 483.507,
    y2: 397.748
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.779,
    x2: 259.35,
    xlinkHref: "#lg7",
    y1: 345.783,
    y2: 345.783
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.779,
    x2: 259.35,
    xlinkHref: "#lg7",
    y1: 419.117,
    y2: 419.117
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 497.643,
    x2: 384.309,
    xlinkHref: "#lg5",
    y1: 242.054,
    y2: 292.054
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-1 0 0 1 919.7 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 907.343,
    x2: 794.009,
    xlinkHref: "#lg5",
    y1: 242.054,
    y2: 292.054
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.212,
    x2: 350.717,
    xlinkHref: "#lg5",
    y1: 262.921,
    y2: 200.426
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.186,
    x2: 350.84,
    xlinkHref: "#lg1",
    y1: 190.57,
    y2: 211.224
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.646,
    x2: 350.504,
    xlinkHref: "#lg6",
    y1: 200.029,
    y2: 210.887
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.949,
    x2: 357.416,
    xlinkHref: "#lg1",
    y1: 216.514,
    y2: 235.981
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.058,
    x2: 347.058,
    xlinkHref: "#lg6",
    y1: 230.442,
    y2: 240.207
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.453,
    x2: 362.507,
    xlinkHref: "#lg6",
    y1: 224.807,
    y2: 221.41
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.609,
    x2: 384.02,
    xlinkHref: "#lg1",
    y1: 213.942,
    y2: 235.353
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.457,
    x2: 373.457,
    xlinkHref: "#lg6",
    y1: 226.522,
    y2: 213.059
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.609,
    x2: 373.609,
    xlinkHref: "#lg6",
    y1: 228.686,
    y2: 240.418
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.693,
    x2: 388.679,
    xlinkHref: "#lg1",
    y1: 192.379,
    y2: 209.365
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.01,
    x2: 366.943,
    xlinkHref: "#lg6",
    y1: 206.905,
    y2: 197.132
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.686,
    x2: 371.003,
    xlinkHref: "#lg1",
    y1: 177.098,
    y2: 197.415
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.065,
    x2: 350.989,
    xlinkHref: "#lg6",
    y1: 187.888,
    y2: 197.818
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.669,
    x2: 361.177,
    xlinkHref: "#lg2",
    y1: 226.665,
    y2: 209.173
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.26,
    x2: 365.611,
    xlinkHref: "#lg7",
    y1: 203.256,
    y2: 213.607
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.333,
    x2: 360.333,
    y1: 211.588,
    y2: 218.628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m171.5 44.517h167v268h-167z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 44.517h83.5v268h-83.5z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.5 44.517h167v87.946h-167z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m290.309 276.464h-70.618l17.93-207.257h34.758z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.29 72.578c-16.177-21.72-42.404-21.72-58.581 0l-.786 1.055 9.713 13.041c11.246 15.1 29.48 15.1 40.727 0l9.713-13.041z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m70.518 494.464h-55.036c-5.237 0-9.482-4.245-9.482-9.482v-18.018h74v18.018c0 5.236-4.245 9.482-9.482 9.482z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.518 494.464h-55.036c-5.237 0-9.482-4.245-9.482-9.482v-18.018h74v18.018c0 5.236-4.245 9.482-9.482 9.482z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m233.25 313.956v118.527c0 42.515 34.465 76.98 76.98 76.98h82.2c9.538 0 17.27-7.732 17.27-17.27v-284.706c0-3.65 2.98-6.07 6.1-6.07 1.48 0 3 .55 4.24 1.79 1.13 1.13 1.77 2.67 1.77 4.28v255.776c0 6.56 5.31 11.87 11.86 11.87h64.47c6.55 0 11.86-5.31 11.86-11.87v-270.946c0-20.08-3.99-39.76-11.53-57.96-7.53-18.2-18.62-34.93-32.82-49.13-13.72-13.72-29.31-25.13-46.18-34-.04-.01-.07-.03-.1-.05-8.85-4.65-18.05-8.59-27.51-11.79-19.56-6.63-40.23-10.1-61.27-10.1h-2.16c-4.66 134.939-60.766 229.288-90.472 270.148-3.068 4.22-4.708 9.304-4.708 14.521z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.089 274.187c40.856-11.95 78.77-54.494 92.319-71.056 3.15-3.851 3.284-9.342.329-13.345l-11.415-15.466c-2.206-2.988-1.042-7.252 2.375-8.706l17.138-7.293c4.567-1.943 7.33-6.656 6.751-11.586-5.538-47.159-34.156-117.448-34.156-117.448-3.865 111.908-43.112 195.897-73.341 244.614z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.25 429.464v3.02c0 42.515 34.465 76.98 76.98 76.98h82.2c9.538 0 17.27-7.732 17.27-17.27v-62.73z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.911 274.187c-6.154 9.901-11.931 18.342-16.953 25.249-3.068 4.22-4.708 9.303-4.708 14.52v118.527c0 42.515 34.465 76.98 76.98 76.98h82.2c9.538 0 17.27-7.732 17.27-17.27v-63.217z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.75 358.602v73.881c0 42.515-34.465 76.98-76.98 76.98h-82.2c-9.538 0-17.27-7.732-17.27-17.27v-284.706c0-3.65-2.98-6.07-6.1-6.07-1.48 0-3 .55-4.24 1.79-1.13 1.13-1.77 2.67-1.77 4.28v255.776c0 6.56-5.31 11.87-11.86 11.87h-64.47c-6.55 0-11.86-5.31-11.86-11.87v-270.946c0-20.08 3.99-39.76 11.53-57.96 7.53-18.2 18.62-34.93 32.82-49.13 13.72-13.72 29.31-25.13 46.18-34 .04-.01.07-.03.1-.05 8.85-4.65 18.05-8.59 27.51-11.79 19.56-6.63 40.23-10.1 61.27-10.1h2.16c3.736 108.19 40.544 190.288 70.3 239.644 16.314 27.06 24.88 58.074 24.88 89.671z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.165 158.321 17.138 7.293c3.417 1.454 4.581 5.718 2.375 8.706l-11.415 15.466c-2.955 4.003-2.821 9.494.329 13.345 13.549 16.563 51.463 59.106 92.319 71.056v-.001c-.982-1.767-1.994-3.519-3.04-5.255-29.757-49.357-66.564-131.454-70.3-239.644 0 0-28.618 70.289-34.157 117.448-.58 4.93 2.184 9.642 6.751 11.586z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.3 429.464v62.73c0 9.538 7.732 17.27 17.27 17.27h82.2c42.515 0 76.98-34.465 76.98-76.98v-3.02z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315.118 9.446c-39.194-11.879-81.041-11.879-120.236 0-6.977 2.115-10.501 9.835-7.591 16.52 11.65 26.76 37.584 31.237 67.709 31.237s56.059-4.477 67.709-31.237c2.91-6.685-.614-14.405-7.591-16.52z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.118 9.446c-39.194-11.879-81.041-11.879-120.236 0-6.977 2.115-10.501 9.835-7.591 16.52 11.65 26.76 37.584 31.237 67.709 31.237s56.059-4.477 67.709-31.237c2.91-6.685-.614-14.405-7.591-16.52z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 51.456c-28.791 0-40.069-17.927-47.057-36.277-1.399-3.674-2.094-6.116-2.431-7.525-.2-.836-1.029-1.351-1.868-1.166l-21.058 4.645c-8.843 2.12-15.078 10.027-15.078 19.12v62.122c0 4.318 4.51 7.155 8.402 5.284l76.894-36.962c1.343-.645 2.197-2.003 2.197-3.493v-5.748z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 57.203c0 1.49.854 2.848 2.197 3.493l76.894 36.962c3.892 1.871 8.402-.965 8.402-5.284v-62.121c0-9.093-6.235-17-15.078-19.12l-21.058-4.645c-.839-.185-1.668.331-1.868 1.166-.337 1.409-1.032 3.85-2.431 7.525-6.988 18.35-18.267 36.277-47.057 36.277v5.747z",
    fill: "url(#SVGID_18_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m256.205 335.57c-3.17-3.712-7.876-6.073-13.141-6.073-9.547 0-17.286 7.739-17.286 17.286 0 5.264 2.361 9.97 6.073 13.141l106.047 106.047c3.17 3.712 7.877 6.073 13.141 6.073 9.547 0 17.286-7.739 17.286-17.286 0-5.264-2.361-9.97-6.073-13.141z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.76 509.464h-46.53c-.74 0-1.47-.01-2.21-.04l-76.17-76.17c-3.71-3.17-6.07-7.87-6.07-13.14 0-4.77 1.94-9.09 5.06-12.22.74-.74 1.55-1.41 2.41-2 2.79-1.93 6.17-3.06 9.81-3.06 5.27 0 9.97 2.36 13.15 6.07z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.065 363.069c-9.547 0-17.286-7.739-17.286-17.286 0-9.547 7.739-17.286 17.286-17.286 9.547 0 17.286 7.739 17.286 17.286-.001 9.547-7.74 17.286-17.286 17.286z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.065 436.402c-9.547 0-17.286-7.739-17.286-17.286 0-9.547 7.739-17.286 17.286-17.286 9.547 0 17.286 7.739 17.286 17.286-.001 9.547-7.74 17.286-17.286 17.286z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.8 201.417c1.48 0 3 .55 4.24 1.79 1.13 1.13 1.77 2.67 1.77 4.28v255.776c0 6.56 5.31 11.87 11.86 11.87h64.47c6.55 0 11.86-5.31 11.86-11.87v-270.946c0-20.08-3.99-39.76-11.53-57.96-7.53-18.2-18.62-34.93-32.82-49.13-13.72-13.72-29.31-25.13-46.18-34-.04-.01-.07-.03-.1-.05-3.179-1.67-6.405-3.245-9.67-4.731v161.041c0-3.65 2.98-6.07 6.1-6.07z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.2 201.417c-1.48 0-3 .55-4.24 1.79-1.13 1.13-1.77 2.67-1.77 4.28v255.776c0 6.56-5.31 11.87-11.86 11.87h-64.47c-6.55 0-11.86-5.31-11.86-11.87v-270.946c0-20.08 3.99-39.76 11.53-57.96 7.53-18.2 18.62-34.93 32.82-49.13 13.72-13.72 29.31-25.13 46.18-34 .04-.01.07-.03.1-.05 3.179-1.67 6.405-3.245 9.67-4.731v161.041c0-3.65-2.98-6.07-6.1-6.07z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.75 190.199c-.811-.143-1.535-.394-2.154-.747-.196-.112-3.943-1.954-7.879-2.275l-7.442-7.369-42.144 32.208 5.165 5.201c-.002.002-.004.004-.006.006-.241.241-.476.487-.703.736-3.908 4.296-1.342 13.232-1.229 13.552.237.672.355 1.429.352 2.253-.009 2.335.978 4.033 2.679 4.891l72.31 72.31v-103.125l-14.922-14.922c-.706-1.4-2.074-2.375-4.027-2.719z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m330.132 211.015c-4.609-3.533-3.672-12.783-3.617-13.118.114-.703.096-1.47-.054-2.279-.624-3.378 1.073-5.822 4.456-6.419.811-.143 1.535-.394 2.154-.747.295-.168 8.633-4.281 13.555-1.198.286.179.569.366.849.56 8.162 5.665 11.319 15.242 6.517 22.159-4.801 6.917-14.877 7.308-23.039 1.643-.28-.195-.554-.396-.821-.601z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.992 209.973c-4.799 6.916-14.876 7.308-23.039 1.641-.281-.195-.554-.394-.82-.599-1.611-1.234-2.545-3.168-3.075-5.174l18.937-18.937c.214.103.426.219.631.347.286.18.569.367.85.562 8.161 5.665 11.317 15.242 6.516 22.16z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.042 237.412c-4.296 3.908-13.232 1.342-13.552 1.229-.672-.237-1.429-.355-2.253-.352-3.435.014-5.539-2.09-5.525-5.525.003-.824-.115-1.581-.352-2.253-.113-.32-2.679-9.257 1.229-13.552.227-.249.461-.495.702-.736 7.025-7.025 17.01-8.431 22.964-2.477s4.549 15.939-2.477 22.964c-.242.241-.487.475-.736.702z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.639 227c.261 1.954.676 3.386.72 3.511.237.672.355 1.429.352 2.253-.014 3.435 2.09 5.539 5.525 5.525.824-.003 1.581.115 2.253.352.32.113 9.257 2.679 13.552-1.229.249-.227.495-.461.736-.702 2.897-2.897 4.835-6.296 5.699-9.709h-28.837z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.255 213.745c-3.485-3.485-8.351-4.445-13.197-3.236v28.859c3.062.402 7.376.415 9.984-1.956.249-.227.495-.461.736-.702 7.025-7.026 8.431-17.011 2.477-22.965z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.625 237.412c4.296 3.908 13.232 1.342 13.552 1.229.672-.237 1.429-.355 2.253-.352 3.435.014 5.539-2.09 5.525-5.525-.003-.824.115-1.581.352-2.253.113-.32 2.679-9.257-1.229-13.552-.227-.249-.461-.495-.703-.736-7.025-7.025-17.01-8.431-22.964-2.477s-4.549 15.939 2.477 22.964c.242.241.488.475.737.702z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.625 237.412c4.296 3.908 13.232 1.342 13.552 1.229.672-.237 1.429-.355 2.253-.352 3.435.014 5.539-2.09 5.525-5.525-.003-.824.115-1.581.352-2.253.113-.32 2.679-9.257-1.229-13.552-.227-.249-.461-.495-.703-.736-7.025-7.025-17.01-8.431-22.964-2.477s-4.549 15.939 2.477 22.964c.242.241.488.475.737.702z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.19 227c.864 3.413 2.802 6.813 5.699 9.709.241.241.487.476.736.702 4.296 3.908 13.232 1.342 13.552 1.229.672-.237 1.429-.355 2.253-.352 3.435.014 5.539-2.09 5.525-5.525-.003-.824.115-1.581.352-2.253.044-.125.459-1.557.72-3.511h-28.837z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.535 211.015c4.609-3.533 3.672-12.783 3.617-13.118-.114-.703-.096-1.47.054-2.279.624-3.378-1.073-5.822-4.456-6.419-.811-.143-1.535-.394-2.154-.747-.295-.168-8.633-4.281-13.555-1.198-.286.179-.569.366-.85.56-8.162 5.665-11.319 15.242-6.517 22.159 4.801 6.917 14.877 7.308 23.039 1.643.28-.195.555-.396.822-.601z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.646 205.696c-.522 2.057-1.461 4.055-3.112 5.319-.266.204-.54.404-.82.599-8.162 5.667-18.239 5.275-23.039-1.641-4.802-6.918-1.646-16.495 6.517-22.159.281-.195.564-.382.85-.562.244-.153.498-.288.756-.407z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.82 185.314c0 9.936-6.067 17.989-14.487 17.989-1.434 0-2.801-.234-4.081-.671-.03-5.373-3.26-10.988-8.778-14.818-.28-.195-.564-.382-.849-.561-.235-.148-.479-.278-.729-.394-.033-.509-.05-1.024-.05-1.545 0-.341.009-.68.024-1.017.274-5.802 8.407-10.306 8.714-10.452.321-.155.637-.344.944-.568.308-.225.608-.485.898-.776 1.211-1.219 2.559-1.829 3.907-1.829s2.697.61 3.907 1.829c.579.584 1.199 1.036 1.842 1.344.307.146 8.44 4.65 8.714 10.452.015.337.024.676.024 1.017z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.057 174.774c-2.448 1.624-6.982 5.215-7.186 9.522-.016.337-.024.676-.024 1.017 0 .521.017 1.036.05 1.545.25.116.493.247.729.394.285.179.569.366.849.561 5.518 3.83 8.748 9.445 8.778 14.818 1.279.437 2.646.671 4.081.671 5.55 0 10.077-3.501 12.519-8.733z",
    fill: "url(#SVGID_37_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m360.481 196.775c-6.463 0-11.703 5.24-11.703 11.703 0 3.389 1.442 6.44 3.744 8.577l22.396 22.396c2.329-.241 4.119-.76 4.259-.809.672-.237 1.429-.355 2.253-.352 3.435.014 5.539-2.09 5.525-5.525-.003-.824.115-1.581.352-2.253.099-.282 2.099-7.243-.093-11.835l-18.157-18.157c-2.136-2.303-5.187-3.745-8.576-3.745zm1.931 16.97c-.839.839-1.527 1.761-2.079 2.741-.552-.98-1.239-1.901-2.079-2.741-1.415-1.415-3.058-2.409-4.834-3.016.197-.244.39-.494.572-.757 1.626-2.343 2.337-4.99 2.252-7.688.004.116.008.231.008.347 1.279.437 2.646.671 4.081.671 1.437 0 2.803-.24 4.085-.678-.017 2.579.699 5.104 2.256 7.348.182.263.375.513.572.757-1.776.607-3.419 1.602-4.834 3.016z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 360.333,
    cy: 208.329,
    fill: "url(#SVGID_39_)",
    r: 11.703
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.656 209.07c.382 6.118 5.463 10.962 11.677 10.962s11.295-4.844 11.677-10.962z",
    fill: "url(#SVGID_40_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeddingSuit);
export default __webpack_public_path__ + "static/media/icon-wedding-suit.313ac6f2cac7b6182041e2c3d982ad3a.svg";
export { ForwardRef as ReactComponent };